import React from 'react';
import {Layout, LayoutChild} from "../../../../palette/Palette";
import Avatar from '@material-ui/core/Avatar';
import {makeStyles} from '@material-ui/core/styles';
import {green} from '@material-ui/core/colors';
import LocalTaxiIcon from '@material-ui/icons/LocalTaxi';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import Text from "../../../../palette/Text";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxShadow: '1px 1px 6px 1px gray',
        borderRadius: 5,
        marginTop: 10,
        backgroundColor: 'white',
        width: 300,
        '& > *': {
            margin: theme.spacing(2),
        },
    },
    client: {
        color: '#fff',
        backgroundColor: '#f73378',
    },

    driver: {
        color: '#fff',
        backgroundColor: '#4dabf5',
    },

    passenger: {
        color: '#fff',
        backgroundColor: green[500],
    },

}));

const Card = ({data, text, color}) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Avatar className={color}>
                {text === 'NUEVOS CLIENTES' && <PersonAddIcon/>}
                {text === 'CONDUCTORES ACTIVOS' && <LocalTaxiIcon/>}
                {text === 'CLIENTES ACTIVOS' && <PermContactCalendarIcon/>}
            </Avatar>
            <LayoutChild color="transparent">
                <Text hover={false} size={12} weight="700" text={text}/>
                <Text hover={false} size={9} weight="600" color={'#546e7a'} text={`TOTAL: ${data}`}/>
            </LayoutChild>
        </div>

    )
}


function Actives(props) {

    const {activeDrivers, activePassengers, newPassengers} = props

    const classes = useStyles();

    return (
        <Layout color="#fff" center positionC>
            <Card data={newPassengers} text={'NUEVOS CLIENTES'} color={classes.client}/>
            <div style={{height: 15}}/>
            <Card data={activeDrivers} text={'CONDUCTORES ACTIVOS'} color={classes.driver}/>
            <div style={{height: 15}}/>
            <Card data={activePassengers} text={'CLIENTES ACTIVOS'} color={classes.passenger}/>
        </Layout>
    )
}

export default Actives